export const AGREE_ALL_BUTTON = 'AGREE_ALL_BUTTON';
export const AGREE_ALL_IN_SPECIFIC_BUTTON = 'AGREE_ALL_BUTTON';
export const AGREE_PERSONAL_INFORMATION_USAGE = 'AGREE_PERSONAL_INFORMATION_USAGE';
export const AGREE_PERSONAL_INFORMATION_PROVISION =
  'AGREE_PERSONAL_INFORMATION_PROVISION';
export const AGREE_IDENTIFICATION_INFORMATION_COLLECTION =
  'AGREE_IDENTIFICATION_INFORMATION_COLLECTION';
export const AGREE_SENSITIVE_INFORMATION_COLLECTION =
  'AGREE_SENSITIVE_INFORMATION_COLLECTION';
export const CANCEL_TREATMENT_BUTTON = 'CANCEL_TREATMENT_BUTTON';
export const START_TREATMENT_BUTTON = 'START_TREATMENT_BUTTON';
